 import { Component } from '@angular/core';
import { InternationalService } from './international.service';
import { TranslateService, Lang } from '@root/shared/service/translate.service';
import _ from 'lodash';
import { loadScript, loadScriptsInSequence } from '@root/util/require-script';
import { Title, Meta } from '@angular/platform-browser';
import { AppService } from './app.service';
@Component({
  selector: 'host-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  get isInternational () {
    return this.app.app.international;
  }

  constructor(
    private translateService: TranslateService,
    private internationalService: InternationalService,
    private title: Title,
    private meta: Meta,
    private app: AppService
  ) {
    console.log('%cInternational Init', 'font-weight: 900');
    this.initI18nInfo();
    // this.initLanguage();
    // this.initDownloadInfo();

  }

  private initI18nInfo () {
    // 通用设置
    // 如果用户未登录，则该接口将不返回数据，语言由本地判断
    this.initInternationalSetting();
    // 本地语言判断，用于用户未登录时，设置默认语言
    this.initLanguageInfo();
    // html meta info
    this.initMetaInfo();
    // 应用商店宣传info
    this.initDownloadInfo();
    // 加载第三方脚本
    this.initScriptsInfo();
  }

  private initInternationalSetting() {
    if (this.isInternational) {
      this.internationalService.initInternationalInfo();
    }
  }

  private initLanguageInfo () {
    if (this.isInternational) {
      const storeLang = this.translateService.getStoreLang();
      if (storeLang !== null) {
        this.internationalService.setLanguage(storeLang);
      } else {
        this.internationalService.setLanguage(Lang.EN);
      }
    } else {
      this.internationalService.setLanguage(Lang.ZH);
    }
  }

  private initMetaInfo() {
    if (this.isInternational) {
      this.updateMetaInfo(Lang.EN);
    } else {
      this.updateMetaInfo(Lang.ZH)
    }
  }

  private initScriptsInfo () {
    if (this.isInternational) {
      this.loadGoogleMap();
      this.loadLiveChat();
    } else {
      this.loadAMap();
    }
  }

  // initLanguage() {
  //   /** 先用域名判断是否国际版，作为默认值 */
  //   if (
  //     location.href.indexOf('hostex.io') !== -1
  //     || location.href.indexOf('g.test') !== -1
  //     || location.href.indexOf('localhost') !== -1
  //   ) {

  //     this.internationalService.setInternational(true);
  //     /** 设置语言默认值，如果本地有存储，说明登录页面设置过默认语言，则将存储的语言设置为默认值，否则将英文设置为默认值 */
  //     const storeLang = this.translateService.getStoreLang();
  //     if (storeLang !== null) {
  //       this.internationalService.setLanguage(storeLang);
  //       // this.translateService.setCurrentLang(storeLang);
  //     } else {
  //       this.internationalService.setLanguage(Lang.EN);
  //       // this.translateService.setCurrentLang(Lang.EN);
  //     }

  //     this.updateMetaInfo(Lang.EN);
  //   } else {
  //     /** 国内版设置中文为默认值 */
  //     this.internationalService.setInternational(false);
  //     this.internationalService.setLanguage(Lang.ZH);
  //     // this.translateService.setCurrentLang(Lang.ZH);
  //     this.updateMetaInfo(Lang.ZH);
  //   }
  // }

  private initDownloadInfo () {
    this.internationalService.fetchInternationHost().subscribe(res => {
      const downloadInfo = _.get(res, 'data.app');
      this.internationalService.setDownloadInfo(downloadInfo);
    });
  }

  private updateMetaInfo (lang: Lang) {
    const cnHead = {
      title: '百居易Hostex - 民宿管理系统 - 轻松管理大量民宿房源',
      description: '官方直连爱彼迎、美团民宿、途家、携程等多平台，房态、房价、房客消息一站式管理，自动关房和回复咨询，不同业务规模均可高效运营。支持Web和独立App。',
      keywords: '短租民宿,酒店客栈pms,管理系统,宝寓,订单来了,云掌柜,民宿宝,去呼呼,番茄来了'
    };
    const enHead = {
      title: 'Hostex - Airbnb short-term & vacation rental property management software',
      description: 'Hostex is a short-term & vacation rental property management software. Integration with Airbnb, Booking, etc., one-stop management of availability, rates, guest messages and reservations. Helps you manage a large number of listings efficiently.',
      keywords: 'bnb,vacation rental,short term rental management,property management,guesty,smartbnb,igms,syncbnb,yourporter,lodgify'
    };

    if (lang === Lang.ZH) {
      this.title.setTitle(cnHead.title);
      this.meta.updateTag({ content: cnHead.description }, 'name="description"');
      this.meta.updateTag({ content: cnHead.keywords }, 'name="keywords"');
    } else {
      this.title.setTitle(enHead.title);
      this.meta.updateTag({ content: enHead.description }, 'name="description"');
      this.meta.updateTag({ content: enHead.keywords }, 'name="keywords"');
    }
  }

  private loadGoogleMap () {
    loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyCnlzWGMpq-LqhG6WNiddwbLb3XLxGmGXI&libraries=&v=weekly', { async: true })
  }

  private loadAMap () {
    // loadScriptsInSequence([
    //   '//webapi.amap.com/maps?v=1.4.8&key=f037e73a0a2dd6233dfa334855df3951&plugin=AMap.ToolBar,AMap.Geolocation,AMap.Marker,AMap.Geocoder,AMap.ElasticMarker',
    //   '//webapi.amap.com/ui/1.0/main.js'
    // ]);
  }

  /** @description 第三方客服 */
  private loadLiveChat () {
    console.log('::start init LiveChat');
    const script = document.createElement('script');
    script.innerHTML = `
    window.__lc = window.__lc || {};
    window.__lc.license = 13897164;
    ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
    `;

    document.body.appendChild(script);
    console.log('::end init LiveChat');
    window['LiveChatWidget'].call('set_customer_name', '');
    window['LiveChatWidget'].call('set_customer_email', '');
  }
}
